var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.932,
    height: 15.359,
    viewBox: "0 0 16.932 15.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-dashboard-6200761",
    transform: "translate(-4.5 -7.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_05_dashboard",
    "data-name": "05 dashboard",
    transform: "translate(4.5 7.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3881",
    "data-name": "Rectangle 3881",
    width: 10.007,
    height: 5.346,
    rx: 2.673,
    transform: "translate(0 0)",
    fill: "#a4e3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3882",
    "data-name": "Rectangle 3882",
    width: 10.007,
    height: 8.79,
    rx: 3.729,
    transform: "translate(0 6.569)",
    fill: "#a4e3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3883",
    "data-name": "Rectangle 3883",
    width: 5.412,
    height: 15.359,
    rx: 2.706,
    transform: "translate(11.519 0)",
    fill: "#a4e3d9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconLight);
export default __webpack_public_path__ + "static/media/dashboard-icon-light.2881202230f9f49c0029b18c45237c24.svg";
export { ForwardRef as ReactComponent };